import React from 'react';
import { translate as t } from '../../lib/I18n';
import config from '../../config';
import Link from '../general/Link';
import { PointStages } from '../../constants/AppConstants';
import FeatureFlagStore from '../../stores/FeatureFlagStore';

export const Logo = () => {
    const brandMainSiteUrl = config.get('mainSiteUrl');
    const isProd = config.get('environment') === 'prod';
    const enableLogoRedirectToSearchPage = !isProd || FeatureFlagStore.get('enableLogoRedirectToSearchPage');

    if (enableLogoRedirectToSearchPage) {
        return (
            <Link to={ PointStages.SEARCH } tabIndex="0" className="header__logo sr-container">
                <span className="sr-text">{ t('app.owner') }</span>
            </Link>
        );
    }

    return (
        <a href={brandMainSiteUrl} tabIndex="0" className="header__logo sr-container">
            <span className="sr-text">{ t('app.owner') }</span>
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js